"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactBar = ContactBar;
var React = _interopRequireWildcard(require("react"));
var _uiKit = require("@cian/ui-kit");
var _ContactMainInfo = require("../../internal/components/ContactMainInfo");
var _internal = require("../partials/ContactAvatar/internal");
var styles = _interopRequireWildcard(require("./styles.module.css"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const AVATAR_CONTEXT = {
  size: 64
};
/**
 * Компонент Контакта для встраивания в карточки на странице выдачи
 *
 * Только для десктопа
 */
function ContactBar(_ref) {
  let {
    title,
    name,
    href,
    target,
    onNameClick,
    nameIcons,
    avatar,
    labels,
    actions,
    qualityInfo
  } = _ref;
  return /*#__PURE__*/React.createElement(_uiKit.UiKitContextProvider, {
    useStaticDeviceType: true,
    deviceType: "desktop"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['contact']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['avatar']
  }, /*#__PURE__*/React.createElement(_internal.ContactAvatarContext.Provider, {
    value: AVATAR_CONTEXT
  }, avatar)), /*#__PURE__*/React.createElement("div", {
    className: styles['content']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['main-info']
  }, /*#__PURE__*/React.createElement(_ContactMainInfo.ContactMainInfo, {
    NameHeadingComponent: _uiKit.UIHeading4,
    title: title,
    name: name,
    href: href,
    target: target,
    onNameClick: onNameClick,
    nameIcons: nameIcons,
    qualityInfo: qualityInfo
  })), labels), actions && /*#__PURE__*/React.createElement("div", {
    className: styles['actions']
  }, actions)));
}